import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';

@Component({
  selector: 'app-tooltip',
  templateUrl:
    'console/app-js/shared/components/tool-tip/tooltip.component.html'
})
export class ToolTipComponent {
  @Output() hovershowTooltip = new EventEmitter();
  @ViewChild(TooltipDirective, { static: true })
  public tooltipDir: TooltipDirective;

  /**
   * function to show tooltip
   */
  public showTooltip($event: any): void {
    this.tooltipDir.toggle($event.target);
    this.hovershowTooltip.emit($event);
  }
}
